import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getLockTransactions } from '../../api/lockTransactions';
import { setTransactionLocking } from '../../redux/modules/auth';

const useLockTransactionModule = () => {
  const dispatch = useDispatch();
  const { isAuthed } = useSelector(({ auth }) => auth);

  useEffect(() => {
    if (isAuthed) {
      loadData();
    }
  }, []);

  const loadData = async () => {
    try {
      const res = await getLockTransactions();

      const { code, result } = res.data.response;

      if (code !== '00000') {
        toast.error(result);
        return;
      }

      dispatch(setTransactionLocking(result));
    } catch (error) {
      toast.error(error.message);
    }
  };

  const refetchLockTransactionModule = () => {
    loadData();
  };

  return {
    refetchLockTransactionModule,
  };
};

export default useLockTransactionModule;
